import { FC } from 'react';

interface ISvgProps {}

export const DocIcon: FC<ISvgProps> = () => {
	return (
		<svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M12 0.5H4C3.46957 0.5 2.96086 0.710714 2.58579 1.08579C2.21071 1.46086 2 1.96957 2 2.5V17.5C2 18.0304 2.21071 18.5391 2.58579 18.9142C2.96086 19.2893 3.46957 19.5 4 19.5H16C16.5304 19.5 17.0391 19.2893 17.4142 18.9142C17.7893 18.5391 18 18.0304 18 17.5V6.5L12 0.5Z"
				fill="#5183F8"
			/>
			<path
				d="M11.9961 5.49609V0.5L18 6.49609H12.9961C12.4438 6.49609 11.9961 6.04838 11.9961 5.49609Z"
				fill="#3A66D6"
			/>
			<path
				d="M6.25564 11.6365H4.85564V14.9365H6.25564C7.29064 14.9365 7.85564 14.3415 7.85564 13.2865C7.85564 12.2315 7.29064 11.6365 6.25564 11.6365ZM6.17064 14.2865H5.71564V12.2865H6.17064C6.73064 12.2865 6.97564 12.6265 6.97564 13.2865C6.97564 13.9465 6.73064 14.2865 6.17064 14.2865ZM10.0945 11.5865C9.08951 11.5865 8.47451 12.2215 8.47451 13.2865C8.47451 14.3515 9.08951 14.9865 10.0945 14.9865C11.0995 14.9865 11.7095 14.3515 11.7095 13.2865C11.7095 12.2215 11.0995 11.5865 10.0945 11.5865ZM10.0945 12.2615C10.5695 12.2615 10.8295 12.6115 10.8295 13.2865C10.8295 13.9615 10.5695 14.3115 10.0945 14.3115C9.61451 14.3115 9.35451 13.9615 9.35451 13.2865C9.35451 12.6115 9.61451 12.2615 10.0945 12.2615ZM15.396 13.9915L14.616 13.7715C14.536 14.1415 14.331 14.3115 13.961 14.3115C13.476 14.3115 13.211 13.9565 13.211 13.2865C13.211 12.6115 13.496 12.2615 13.976 12.2615C14.316 12.2615 14.506 12.3915 14.601 12.8015L15.356 12.4965C15.191 11.8715 14.636 11.5865 13.946 11.5865C12.951 11.5865 12.331 12.2215 12.331 13.2865C12.331 14.3515 12.946 14.9865 13.951 14.9865C14.651 14.9865 15.201 14.6815 15.396 13.9915Z"
				fill="white"
			/>
		</svg>
	);
};
